import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import { space } from 'styled-system';

import type { SpaceProps } from 'common/theme/system-types';
import ActionItem from './ActionIcons/ActionItem';
import Tooltip from './ActionIcons/MyAccountTooltip/Tooltip';
import type { ActionItemConfig } from './types';

interface ToolbarActionItemProps extends ActionItemConfig {
  isNewIcon?: boolean;
}

const RightSectionItem = styled.div<SpaceProps>`
  ${space};

  &:first-of-type {
    margin-left: 0;
  }
`;

const rightSectionItemStyles: ComponentProps<typeof RightSectionItem> = {
  ml: ['sp_0', 'sp_8', 'sp_16', 'sp_24'],
};

const ToolbarActionItem = ({
  Subscription = ({ children }) => children({}),
  showTooltip,
  isNewIcon,
  ...item
}: ToolbarActionItemProps) => (
  <RightSectionItem {...rightSectionItemStyles}>
    <Subscription {...item}>
      {({ value }) => (
        <ActionItem
          id={item.id}
          icon={item.icon}
          label={item.label}
          url={item.url}
          count={value}
          countThreshold={item.countThreshold}
          isNewIcon={isNewIcon}
          showTooltip={showTooltip}
        >
          {({ shouldShowChildren, isActionItemActive }) =>
            showTooltip && shouldShowChildren && isActionItemActive ? (
              <Tooltip customer={value} />
            ) : null
          }
        </ActionItem>
      )}
    </Subscription>
  </RightSectionItem>
);

export default ToolbarActionItem;
